var _excluded = ["routes", "onRouteBefore", "loading", "mode"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import { Navigate, useLocation, BrowserRouter, HashRouter, useNavigate, useRoutes } from 'react-router-dom';
import { Loading } from './components';
export * from './types';
var temp = null;
// 获取数据类型
function getDataType(data) {
  return Object.prototype.toString.call(data).match(/\s(\w+)\]/)[1];
}
function Guard(_ref) {
  var element = _ref.element,
    meta = _ref.meta,
    onRouteBefore = _ref.onRouteBefore;
  meta = meta || {};
  var location = useLocation();
  var pathname = location.pathname;
  var navigate = useNavigate();
  if (onRouteBefore) {
    if (temp === element) {
      return element;
    }
    var pathRes = onRouteBefore({
      pathname: pathname,
      meta: meta
    });
    if (getDataType(pathRes) === 'Promise') {
      pathRes.then(function (res) {
        if (res && res !== pathname) {
          navigate(res, {
            replace: true
          });
        }
      });
    } else {
      if (pathRes && pathRes !== pathname) {
        element = /*#__PURE__*/React.createElement(Navigate, {
          to: pathRes,
          replace: true
        });
      }
    }
  }
  temp = element;
  return element;
}
var RouteMaker = /*#__PURE__*/function () {
  function RouteMaker(option) {
    _classCallCheck(this, RouteMaker);
    this.routes = void 0;
    this.onRouteBefore = void 0;
    this.loading = void 0;
    this.routes = option.routes || [];
    this.onRouteBefore = option.onRouteBefore;
    this.loading = option.loading || /*#__PURE__*/React.createElement(Loading, null);
  }
  return _createClass(RouteMaker, [{
    key: "transformRoutes",
    value: function transformRoutes() {
      var _this = this;
      var routeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.routes;
      var list = [];
      routeList.forEach(function (route) {
        var _obj$children;
        var obj = _objectSpread({}, route);
        if (obj.path === undefined) {
          return;
        }
        if (obj.redirect) {
          obj.element = /*#__PURE__*/React.createElement(Navigate, {
            to: obj.redirect,
            replace: true
          });
        } else if (obj.component) {
          obj.element = _this.lazyLoad(obj.component, obj.meta || {});
        } else if (obj.element && !((_obj$children = obj.children) === null || _obj$children === void 0 ? void 0 : _obj$children.length)) {
          obj.element = /*#__PURE__*/React.cloneElement(obj.element, {
            _meta: obj.meta || {}
          });
          obj.element = /*#__PURE__*/React.createElement(Guard, {
            element: obj.element,
            meta: obj.meta || {},
            onRouteBefore: _this.onRouteBefore
          });
        }
        delete obj.redirect;
        delete obj.component;
        delete obj.meta;
        if (obj.children) {
          obj.children = _this.transformRoutes(obj.children);
        }
        list.push(obj);
      });
      return list;
    }
  }, {
    key: "lazyLoad",
    value: function lazyLoad(importFn, meta) {
      var Element = /*#__PURE__*/React.lazy(importFn);
      var lazyElement = /*#__PURE__*/React.createElement(React.Suspense, {
        fallback: this.loading
      }, /*#__PURE__*/React.createElement(Element, {
        _meta: meta
      }));
      return /*#__PURE__*/React.createElement(Guard, {
        element: lazyElement,
        meta: meta,
        onRouteBefore: this.onRouteBefore
      });
    }
  }]);
}();
function GuardRoutes(_ref2) {
  var routes = _ref2.routes,
    onRouteBefore = _ref2.onRouteBefore,
    loading = _ref2.loading;
  var routeMaker = new RouteMaker({
    routes: routes,
    onRouteBefore: onRouteBefore,
    loading: loading
  });
  var elements = [];
  try {
    var reactRoutes = routeMaker.transformRoutes();
    elements = useRoutes(reactRoutes);
  } catch (_unused) {}
  return elements;
}
function PlusRouter(props) {
  var routes = props.routes,
    onRouteBefore = props.onRouteBefore,
    loading = props.loading,
    mode = props.mode,
    rest = _objectWithoutProperties(props, _excluded);
  var RouterMode = mode === 'hash' ? HashRouter : BrowserRouter;
  return /*#__PURE__*/React.createElement(RouterMode, rest, /*#__PURE__*/React.createElement(GuardRoutes, {
    routes: routes,
    onRouteBefore: onRouteBefore,
    loading: loading
  }));
}
export { GuardRoutes };
export default PlusRouter;